import RefProvider from '../services/ref.provider'
const refService = new RefProvider()

const initialState = {
    levels: [],
    faculties: [],
    // curriculums: [],

    prenames: [],
    bloodTypes: [],
    disabilitys: [],
    districts: [],
    educationTypes: [],
    genders: [],
    geographys: [],
    loginErrorCodes: [],
    loginServices: [],
    matriculationStatuss: [],
    nations: [],
    occupations: [],
    parRelatives: [],
    parStatuss: [],
    //prefix_names: [],
    privileges: [],
    provinces: [],
    races: [],
    religions: [],
    revenues: [],
    schools: [],
    schoolStudyStatuss: [],
    schoolStudyTypes: [],
    schoolTypes: [],
    studentStatuss: [],
    studentStatusSubs: [],
    studentTypes: [],
    subDistricts: [],
    talents: [],
    universitys: [],
    universityStudyStatuss: [],
    vitalStatuss: [],
    zipcodes: [],
    admissionRegisterStatus: [],
};

import { getField, updateField } from 'vuex-map-fields';

export const ref = {
    namespaced: true,
    state: initialState,
    actions: {
        async getLevels({ commit, state }) {
            if (state.levels.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getLevel()
                commit('SET_LEVEL', data)
            }
        },
        async getFaculties({ commit, state }) {
            if (state.faculties.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getFaculty()
                commit('SET_FACULTY', data)
            }
        },
        // async getCurriculums({ commit, state }) {
        //     if (state.curriculums.length === 0) { // if already recieved data, do not call the api
        //         const data = await refService.getCurriculum()
        //         commit('SET_CURRICULUM', data)
        //     }
        // },

        //------------------------------------------------------------------------------------------------

        async getPrenames({ commit, state }) {
            if (state.prenames.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getPrefixName()
                commit('SET_PREFIX_NAME', data)
            }
        },
        async getBloodTypes({ commit, state }) {
            if (state.bloodTypes.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getBloodType()
                commit('SET_BLOOD_TYPE', data)
            }
        },
        async getDisabilitys({ commit, state }) {
            if (state.disabilitys.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getDisability()
                commit('SET_DISABILITY', data)
            }
        },
        async getDistricts({ commit, state }) {
            if (state.districts.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getDistrict()
                commit('SET_DISTRICT', data)
            }
        },
        async getEducationTypes({ commit, state }) {
            if (state.educationTypes.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getEducationType()
                commit('SET_EDUCATION_TYPE', data)
            }
        },
        async getGenders({ commit, state }) {
            if (state.genders.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getGender()
                commit('SET_GENDER', data)
            }
        },
        async getGeographys({ commit, state }) {
            if (state.geographys.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getGeography()
                commit('SET_GEOGRAPHY', data)
            }
        },
        async getLoginErrorCodes({ commit, state }) {
            if (state.loginErrorCodes.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getLoginErrorCode()
                commit('SET_LOGIN_ERROR_CODE', data)
            }
        },
        async getLoginServices({ commit, state }) {
            if (state.loginServices.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getLoginService()
                commit('SET_LOGIN_SERVICE', data)
            }
        },
        async getMatriculationStatuss({ commit, state }) {
            if (state.matriculationStatuss.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getMatriculationStatus()
                commit('SET_MATRICULATION_STATUS', data)
            }
        },
        async getNations({ commit, state }) {
            if (state.nations.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getNation()
                commit('SET_NATION', data)
            }
        },
        async getOccupations({ commit, state }) {
            if (state.occupations.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getOccupation()
                commit('SET_OCCUPATION', data)
            }
        },
        async getParRelatives({ commit, state }) {
            if (state.parRelatives.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getParRelative()
                commit('SET_PAR_RELATIVE', data)
            }
        },
        async getParStatuss({ commit, state }) {
            if (state.parStatuss.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getParStatus()
                commit('SET_PAR_STATUS', data)
            }
        },
        async getPrivileges({ commit, state }) {
            if (state.privileges.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getPrivilege()
                commit('SET_PRIVILEGE', data)
            }
        },
        async getProvinces({ commit, state }) {
            if (state.provinces.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getProvince()
                commit('SET_PROVINCE', data)
            }
        },
        async getRaces({ commit, state }) {
            if (state.races.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getRace()
                commit('SET_RACE', data)
            }
        },
        async getReligions({ commit, state }) {
            if (state.religions.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getReligion()
                commit('SET_RELIGION', data)
            }
        },
        async getRevenues({ commit, state }) {
            if (state.revenues.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getRevenue()
                commit('SET_REVENUE', data)
            }
        },
        async getSchools({ commit, state }) {
            if (state.schools.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getSchool()
                commit('SET_SCHOOL', data)
            }
        },
        async getSchoolTypes({ commit, state }) {
            if (state.schoolTypes.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getSchoolType()
                commit('SET_SCHOOL_TYPE', data)
            }
        },
        async getStudentStatuss({ commit, state }) {
            if (state.studentStatuss.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getStudentStatus()
                commit('SET_STUDENT_STATUS', data)
            }
        },
        async getStudentStatusSubs({ commit, state }) {
            if (state.studentStatusSubs.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getStudentStatusSub()
                commit('SET_STUDENT_STATUS_SUB', data)
            }
        },
        async getStudentTypes({ commit, state }) {
            if (state.studentTypes.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getStudentType()
                commit('SET_SCHOOL_TYPE', data)
            }
        },
        async getSubDistricts({ commit, state }) {
            if (state.subDistricts.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getSubDistrict()
                commit('SET_SUB_DISTRICT', data)
            }
        },
        async getTalents({ commit, state }) {
            if (state.talents.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getTalent()
                commit('SET_TALENT', data)
            }
        },
        async getUniversitys({ commit, state }) {
            if (state.universitys.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getUniversity()
                commit('SET_UNIVERSITY', data)
            }
        },
        async getUniversityStudyStatuss({ commit, state }) {
            if (state.universityStudyStatuss.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getUniversityStudyStatus()
                commit('SET_UNIVERSITY_STUDY_STATUS', data)
            }
        },
        async getVitalStatuss({ commit, state }) {
            if (state.vitalStatuss.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getVitalStatus()
                commit('SET_VITAL_STATUS', data)
            }
        },
        async getZipcodes({ commit, state }) {
            if (state.zipcodes.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getZipcode()
                commit('SET_ZIPCODES', data)
            }
        },
        async getSchoolStudyStatuss({ commit, state }) {
            if (state.schoolStudyStatuss.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getSchoolStudyStatus()
                commit('SET_SCHOOL_STUDY_STATUS', data)
            }
        },
        async getSchoolStudyTypes({ commit, state }) {
            if (state.schoolStudyTypes.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getSchoolStudyType()
                commit('SET_SCHOOL_STUDY_TYPE', data)
            }
        },
        async getAdmissionRegisterStatus({ commit, state }) {
            if (state.admissionRegisterStatus.length === 0) { // if already recieved data, do not call the api
                const data = await refService.getAdmissionRegisterStatus()
                commit('SET_ADMISSION_REGISTER_STATUS', data)
            }
        },
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        SET_LEVEL(state, data) { state.levels = data },
        SET_PREFIX_NAME(state, data) { state.prenames = data },
        SET_BLOOD_TYPE(state, data) { state.bloodTypes = data },
        SET_DISABILITY(state, data) { state.disabilitys = data },
        SET_DISTRICT(state, data) { state.districts = data },
        SET_EDUCATION_TYPE(state, data) { state.educationTypes = data },
        SET_GENDER(state, data) { state.genders = data },
        SET_GEOGRAPHY(state, data) { state.geographys = data },
        SET_LOGIN_ERROR_CODE(state, data) { state.loginErrorCodes = data },
        SET_LOGIN_SERVICE(state, data) { state.loginServices = data },
        SET_MATRICULATION_STATUS(state, data) { state.matriculationStatuss = data },
        SET_NATION(state, data) { state.nations = data },
        SET_OCCUPATION(state, data) { state.occupations = data },
        SET_PAR_RELATIVE(state, data) { state.parRelatives = data },
        SET_PAR_STATUS(state, data) { state.parStatuss = data },
        SET_PRIVILEGE(state, data) { state.privileges = data },
        SET_PROVINCE(state, data) { state.provinces = data },
        SET_RACE(state, data) { state.races = data },
        SET_RELIGION(state, data) { state.religions = data },
        SET_REVENUE(state, data) { state.revenues = data },
        SET_SCHOOL(state, data) { state.schools = data },
        SET_SCHOOL_TYPE(state, data) { state.schoolTypes = data },
        SET_STUDENT_STATUS(state, data) { state.studentStatuss = data },
        SET_STUDENT_STATUS_SUB(state, data) { state.studentStatusSubs = data },
        SET_STUDENT_TYPE(state, data) { state.studentTypes = data },
        SET_SUB_DISTRICT(state, data) { state.subDistricts = data },
        SET_TALENT(state, data) { state.talents = data },
        SET_UNIVERSITY(state, data) { state.universitys = data },
        SET_UNIVERSITY_STUDY_STATUS(state, data) { state.universityStudyStatuss = data },
        SET_VITAL_STATUS(state, data) { state.vitalStatuss = data },
        SET_ZIPCODE(state, data) { state.zipcodes = data },
        SET_SCHOOL_STUDY_STATUS(state, data) { state.schoolStudyStatuss = data },
        SET_SCHOOL_STUDY_TYPE(state, data) { state.schoolStudyTypes = data },
        SET_ADMISSION_REGISTER_STATUS(state, data) { state.admissionRegisterStatus = data },
    },
};